import { useState } from 'react';
import Link from 'next/link';
import { RiArrowRightLine, RiCheckLine } from 'react-icons/ri';

import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from '@/shared/components/ui/dialog';

export const ReplacementRequest = ({
  productName,
  label = 'Подобрать аналог',
  className = 'precision-button precision-button--outline',
}: {
  productName: string;
  label?: string;
  className?: string;
}) => {
  const [open, setOpen] = useState(false);
  const [complete, setComplete] = useState(false);
  return (
    <Dialog
      open={open}
      onOpenChange={(value) => {
        setOpen(value);
        if (!value) setComplete(false);
      }}
    >
      <DialogTrigger asChild>
        <button className={className} type="button">
          {label}
          <RiArrowRightLine aria-hidden />
        </button>
      </DialogTrigger>
      <DialogContent className="replacement-modal">
        <p className="eyebrow">ПОДБОР ОБОРУДОВАНИЯ</p>
        <DialogTitle>Найдём замену под вашу задачу.</DialogTitle>
        <DialogDescription>
          Расскажите, какие параметры важно сохранить. Поможем выбрать модель из актуального ассортимента.
        </DialogDescription>
        <p className="replacement-modal__model">
          <span>Вместо модели</span>
          {productName}
        </p>
        {complete ? (
          <div className="replacement-modal__result" role="status">
            <RiCheckLine aria-hidden />
            <h3>Форма работает.</h3>
            <p>Это тестовая версия: заявка не отправлена, данные никуда не переданы.</p>
            <button className="text-link" type="button" onClick={() => setOpen(false)}>
              Вернуться к аналогам <RiArrowRightLine aria-hidden />
            </button>
          </div>
        ) : (
          <form
            onSubmit={(event) => {
              event.preventDefault();
              setComplete(true);
            }}
          >
            <div className="replacement-modal__fields">
              <label>
                Ваше имя
                <input name="name" autoComplete="name" placeholder="Как к вам обращаться" required minLength={2} />
              </label>
              <label>
                Телефон
                <input
                  name="phone"
                  type="tel"
                  autoComplete="tel"
                  placeholder="+7 (___) ___-__-__"
                  required
                  minLength={10}
                />
              </label>
            </div>
            <label>
              Что важно в новом станке?
              <textarea
                name="requirements"
                placeholder="Материалы, размеры заготовок, нужные функции или бюджет"
                rows={3}
              />
            </label>
            <label className="consent">
              <input type="checkbox" name="consent" required />
              <span>
                Согласен на <Link href="/personal-data">обработку персональных данных</Link>
              </span>
            </label>
            <button className="precision-button" type="submit">
              Запросить подбор <RiArrowRightLine aria-hidden />
            </button>
            <p className="replacement-modal__preview">Демонстрационная форма — данные не отправляются.</p>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
